
import * as THREE from 'three';
import { Matrix4, Object3D } from 'three';
import { Wireframe } from 'three/examples/jsm/lines/Wireframe';
import { GeometryHelpers } from './modelviewer/Helpers/GeometryHelpers';
import { HsbElement, HsbEntity } from './hsbcad-model';


/**
 * @deprecated Refrain from using the Visual. Instead use object.Userdata to store data on the object.
 */
export class HsbVisual {

    entity;
    visible;
    selected = false;
    highlighted = false;
    geometryModel;
    material: THREE.Material | null;
    selectmaterial: THREE.Material | null;
    highlightmaterial: THREE.Material | null;
    hidematerial: THREE.Material | null;
    ghostmaterial: THREE.Material| null;
    originalmaterial: THREE.Material | null;
    geometryLabel;
    /**
     * @deprecated Refrain from using visual. Object and entities should be linked via object.userData
     */
    visualLayer;
    transformCoordSys;
    bBoxFaces; p
    snap;
    instanceId;
    selectable: boolean = true;
    constructor() {

        this.entity = null;
        this.visible = true;
        this.selected = false;
        this.geometryModel = null;
        this.geometryLabel = null;
        this.material = null;
        this.selectmaterial = null;
        this.highlightmaterial = null;
        this.hidematerial = null;
        this.ghostmaterial = null;
        this.originalmaterial = null;
        this.visualLayer = null;
        this.transformCoordSys = null;
        this.bBoxFaces = null;
        this.snap = true;
    }

    show(show) {

        try {
            let showOverride = show;

            if (!this.visualLayer.displayElementLabels && this.entity instanceof HsbElement) {

                if (this.geometryModel) {
                    this.geometryModel.visible = false
                }
            } else {
                this.visible = show;
            }

            var hide = this.hidematerial;

            if (this.geometryModel && this.geometryModel.children) {

                this.geometryModel.traverse(function (geomobject) {
                    if (geomobject instanceof Wireframe || geomobject instanceof THREE.Sprite) {
                        geomobject.visible = show;
                    }
                    else if (geomobject.userData.originalmaterial && geomobject instanceof THREE.Mesh) {
                        var material = (show === true) ? geomobject.userData.originalmaterial : hide;

                        geomobject.material = material;
                    }
                });
            }
            if (this.geometryLabel && this.geometryLabel.children) {

                this.geometryLabel.traverse(function (geomobject) {

                    if (geomobject.userData.originalmaterial) {
                        var material = (show === true) ? geomobject.userData.originalmaterial : hide;

                        geomobject.material = material;
                    }
                });
            }

            this.visible = showOverride;
            show = showOverride;

            if (this.entity instanceof HsbElement) {

                if (this.geometryModel instanceof THREE.Mesh) {
                    this.geometryModel.material = (show) ? this.material : this.hidematerial

                    this.geometryModel.material.needsUpdate = true;
                }
                // WLM - Stop this for now - we are now selecting the element entities outside the visuals
                return;

                // if (this.entity.entities) {
                //     var visuals = HsbVisual.getVisuals(this.visualLayer, this.entity.entities);

                //     visuals.forEach(visual => {
                //         visual.visible = show;
                //         visual.show(show);
                //     });
                // }
            } else {

                if (this.geometryModel instanceof THREE.Mesh) {
                    this.geometryModel.material = (show) ? this.material : this.hidematerial
                    this.geometryModel.material.needsUpdate = true;
                }
                if (this.geometryLabel) {
                    this.geometryLabel.material = (show) ? this.geometryLabel.userData.visibleMaterial : this.hidematerial;
                    this.geometryLabel.visible = show;
                }
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    select(selected) {
        this.selected = selected;
        if (this.highlighted && this.selected)
            this.highlighted = false;

        var selectmaterial = (selected === true) ? this.selectmaterial : this.material;
        var selectmaterialelement = this.selectmaterial;

        if (this.geometryModel && this.geometryModel.children) {

            this.geometryModel.traverse(function (geomobject) {

                if (geomobject.userData.originalmaterial && geomobject instanceof THREE.Mesh) {
                    var material = (selected === true) ? selectmaterialelement : geomobject.userData.originalmaterial;

                    geomobject.material = material;
                }
            });
        }
        if (this.geometryLabel && this.geometryLabel.children) {

            this.geometryLabel.traverse(function (geomobject) {

                if (geomobject.originalmaterial) {
                    var material = (selected === true) ? selectmaterialelement : geomobject.originalmaterial;

                    // geomobject.material = material;
                }
            });
        }
        if (this.entity instanceof HsbElement) {

            if (this.geometryModel instanceof THREE.Mesh) {
                this.geometryModel.material = selectmaterial;
                this.geometryModel.material.needsUpdate = true;
            }

            // WLM - Stop this for now - we are now selecting the element entities outside the visuals
            //return;
            if (this.entity.entities) {
                //var entities = this.entity.getEntities();
                var visuals: HsbVisual[] = HsbVisual.getVisuals(this.visualLayer, this.entity.entities);

                visuals.forEach(visual => {
                    visual.select(selected);
                });
            }
        }
        else {
            if (this.geometryModel instanceof THREE.Mesh) {
                if (this.geometryModel.material) {
                    this.geometryModel.material = selectmaterial;
                    this.geometryModel.material.needsUpdate = true;
                }

            }
        }
    }

    highlight(highlighted) {
        let self = this;
        if (this.selected || !this.visible)
            return;
        this.highlighted = highlighted;

        var highlightmaterial = (highlighted === true) ? this.highlightmaterial : this.material;
        var highlightmaterialelement = this.highlightmaterial;

        if (this.geometryModel && this.geometryModel.children) {

            this.geometryModel.traverse(function (geomobject) {
                if (geomobject instanceof THREE.InstancedMesh) {

                }
                else if (geomobject.userData.originalmaterial && geomobject instanceof THREE.Mesh) {
                    var material = (highlighted === true) ? highlightmaterialelement : geomobject.userData.originalmaterial;

                    geomobject.material = material;
                }
            });
        }
        if (this.geometryLabel && this.geometryLabel.children) {

            this.geometryLabel.traverse(function (geomobject) {

                if (geomobject.userData.originalmaterial) {
                    var material = (highlighted === true) ? highlightmaterialelement : geomobject.userData.originalmaterial;

                    // geomobject.material = material;
                }
            });
        }
        if (this.entity instanceof HsbElement) {

            if (this.geometryModel instanceof THREE.Mesh) {
                this.geometryModel.material = highlightmaterial;
                this.geometryModel.material.needsUpdate = true;
            }

            // WLM - Stop this for now - we are now highlighting the element entities outside the visuals
            //return;
            if (this.entity.entities) {
                //var entities = this.entity.getEntities();
                var visuals: HsbVisual[] = HsbVisual.getVisuals(this.visualLayer, this.entity.entities);

                visuals.forEach(visual => {
                    visual.highlight(highlighted);
                });
            }
        }
        else if (this.geometryModel instanceof THREE.Mesh) {
            if (this.geometryModel instanceof THREE.InstancedMesh) {
                let handles = this.geometryModel.userData.handle;
                if (handles?.length > 0) {
                    let index = handles.findIndex((element) => element === this.entity._handle);
                    if (index > -1) {
                        this.geometryModel.setColorAt(index, new THREE.Color('#fbff70'));
                    }
                }
            }
            else {
                this.geometryModel.material = highlightmaterial;
                this.geometryModel.material.needsUpdate = true;
            }
        }
    }

    color(colorMaterial) {

        this.material = colorMaterial;

        // var visibleMaterial = colorMaterial;

        // if (this.geometryModel && this.geometryModel.children) {

        //     this.geometryModel.traverse(function (geomobject) {

        //         if (geomobject.originalmaterial) {
        //             geomobject.material = visibleMaterial;
        //         }
        //     });
        // }
        // if (this.geometryLabel && this.geometryLabel.children) {

        //     this.geometryLabel.traverse(function (geomobject) {

        //         if (geomobject.originalmaterial) {
        //             geomobject.material = visibleMaterial;
        //         }
        //     });
        // }
        // if (this.entity instanceof HsbElement) {

        //     if (this.entity.entities) {
        //         //var entities = this.entity.getEntities();
        //         var visuals = HsbVisual.getVisuals(this.visualLayer, this.entity.entities);

        //         visuals.forEach(visual => {
        //             visual.color(colorMaterial);
        //         });
        //     }
        // }
        // else {
        //     if (this.geometryModel != null) {
        //         this.geometryModel.material = colorMaterial;
        //         this.geometryModel.material.needsUpdate = true;
        //     }
        // }
    }

    transform(moveCoordSys) {
        if (moveCoordSys && this.geometryModel) {

            var moveMatrix = new Matrix4();
            var coordsys = this.entity.coordSys.clone();

            GeometryHelpers.setToAlignCoordSys(moveMatrix, coordsys.ptOrg, coordsys.vecX, coordsys.vecY, coordsys.vecZ,
                moveCoordSys.ptOrg, moveCoordSys.vecX, moveCoordSys.vecY, moveCoordSys.vecZ);

            var entities = this.entity.entities && this.entity.entities.length > 0 ? this.entity.entities : [this.entity];
            var elementvisuals: HsbVisual[] = HsbVisual.getVisuals(this.visualLayer, entities);

            elementvisuals.forEach(visual => {

                visual.geometryModel.applyMatrix4(moveMatrix);
                visual.geometryModel.updateMatrix();
            });

            this.geometryModel.applyMatrix4(moveMatrix);
            this.geometryModel.updateMatrix();
        }
    }

    transformBy(moveCoordSys) {
        if (moveCoordSys && this.geometryModel) {

            var moveMatrix = new Matrix4();
            GeometryHelpers.setFromCoordSys(moveMatrix, moveCoordSys);

            //var entities = this.entity.entities && this.entity.entities.length > 0 ? this.entity.entities : [this.entity];
            if (this.entity.entities && this.entity.entities.length > 0) {
                var elementvisuals: HsbVisual[] = HsbVisual.getVisuals(this.visualLayer, this.entity.entities);

                elementvisuals.forEach(visual => {
                    visual.geometryModel.applyMatrix4(moveMatrix);
                    visual.geometryModel.updateMatrix();
                });
            }

            this.geometryModel.applyMatrix4(moveMatrix);
            this.geometryModel.updateMatrix();

            if (this.bBoxFaces) {
                let bBoxFaces = this.bBoxFaces;
                Object.keys(bBoxFaces).forEach(function (key) {
                    let face = bBoxFaces[key];
                    face.coordSys.transformBy(moveCoordSys);

                    face.edgePts.forEach(pt => {
                        pt.applyMatrix4(moveMatrix);
                    });
                });
            }

            this.geometryModel.traverse(function (mesh) {
                if (mesh instanceof Object3D) {

                    //this.geometryModel.applyMatrix4(moveMatrix);
                    //mesh.updateMatrix();
                }
            });
        }
    }

    setTransform(moveCoordSys) {
        if (this.geometryModel) {
            var entities = this.entity.entities && this.entity.entities.length > 0 ? this.entity.entities : [this.entity];
            var elementvisuals: HsbVisual[] = HsbVisual.getVisuals(this.visualLayer, entities);

            var moveMatrix = new Matrix4();
            GeometryHelpers.setFromCoordSys(moveMatrix, moveCoordSys);

            elementvisuals.forEach(visual => {

                visual.geometryModel.matrix = moveMatrix.clone();
                visual.geometryModel.matrix.decompose(visual.geometryModel.position, visual.geometryModel.quaternion, visual.geometryModel.scale);
                visual.geometryModel.updateMatrixWorld(true);
            });

            this.geometryModel.matrix = moveMatrix.clone();
            this.geometryModel.matrix.decompose(this.geometryModel.position, this.geometryModel.quaternion, this.geometryModel.scale);
            this.geometryModel.updateMatrixWorld(true);
        }
    }

    resetTransform() {
        if (this.geometryModel) {
            var entities = this.entity.entities && this.entity.entities.length > 0 ? this.entity.entities : [this.entity];
            var elementvisuals = HsbVisual.getVisuals(this.visualLayer, entities);

            elementvisuals.forEach(visual => {

                var coordsys = visual.entity.coordSys.clone();

                if (visual.entity.initialCoordSys) {
                    coordsys = visual.entity.initialCoordSys;
                }

                var moveMatrix = new Matrix4();
                GeometryHelpers.setFromCoordSys(moveMatrix, coordsys);
                visual.geometryModel.matrix = moveMatrix.clone();
                visual.geometryModel.matrix.decompose(visual.geometryModel.position, visual.geometryModel.quaternion, visual.geometryModel.scale);
                visual.geometryModel.updateMatrixWorld(true);
            });

            var coordsys = this.entity.elementCoordSys?.clone() ?? this.entity.coordSys?.clone();

            if (this.entity.initialCoordSys) {
                coordsys = this.entity.initialCoordSys;
            } else if (this.entity.labelCoordSys) {
                //coordsys = this.entity.labelCoordSys;
            }

            var moveMatrix = new Matrix4();
            GeometryHelpers.setFromCoordSys(moveMatrix, coordsys);
            this.geometryModel.matrix = moveMatrix.clone();
            this.geometryModel.matrix.decompose(this.geometryModel.position, this.geometryModel.quaternion, this.geometryModel.scale);
            this.geometryModel.updateMatrix();

            if (this.bBoxFaces) {
                let bBoxFaces = this.bBoxFaces;
                Object.keys(bBoxFaces).forEach(function (key) {
                    let face = bBoxFaces[key];
                    face.coordSys.transformBy(coordsys);

                    face.edgePts.forEach(pt => {
                        pt.applyMatrix4(moveMatrix);
                    });
                });
            }
        }
    }

    resetTransformOLD() {
        if (this.geometryModel && this.transformCoordSys) {

            var moveMatrix = new Matrix4();
            var coordsys = this.entity.coordSys.clone()

            GeometryHelpers.setToAlignCoordSys(moveMatrix, this.transformCoordSys.ptOrg, this.transformCoordSys.vecX, this.transformCoordSys.vecY, this.transformCoordSys.vecZ,
                coordsys.ptOrg, coordsys.vecX, coordsys.vecY, coordsys.vecZ);

            if (!(this.entity instanceof HsbElement)) {
                this.geometryModel.applyMatrix4(moveMatrix);
                this.geometryModel.updateMatrix();
            }
            this.transformCoordSys = null;

            var entities = this.entity.entities
            var elementvisuals = HsbVisual.getVisuals(this.visualLayer, entities);

            elementvisuals.forEach(visual => {

                visual.geometryModel.applyMatrix4(moveMatrix);
            });
        }
    }

    static getVisuals(visualLayer, entities: HsbEntity[]): HsbVisual[] {
        let visuals: HsbVisual[] = [];

        entities.forEach(entity => {

            let visual: HsbVisual = (visualLayer.visuals[entity.hsbmodel.modelId]) ? visualLayer.visuals[entity.hsbmodel.modelId][entity.handle] : null;

            if (visual) {
                visuals.push(visual);
            }
        });

        return visuals;
    }


}
